import React, { useState, useEffect } from 'react'
import { useDataEngine } from '@dhis2/app-runtime';
import { useAuth } from '../auth/AuthContext';
import MyObjectivesList from './MyObjectives';

// Simple context provider for MyObjectives without the add button
const MyObjectivesContext = React.createContext();

const MyObjectivesWrapper = ({ children }) => {
    const engine = useDataEngine();
    const { user } = useAuth();
    const [events, setEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(true);

    useEffect(() => {
        const fetchEvents = async () => {
            if (!user?.organisationUnits?.length) return;

            try {
                const response = await engine.query({
                    events: {
                        resource: 'events',
                        params: {
                            program: 'yiT00XKrrHP',
                            orgUnit: user.organisationUnits[0].id,
                            fields: 'event,orgUnit,storedBy,createdByUserInfo[username],lastUpdatedByUserInfo[username],trackedEntityInstance,enrollment,dataValues[dataElement,value]',
                            pageSize: 100
                        }
                    }
                });
                setEvents(response.events?.events || []);
            } catch (error) {
                console.error('Failed to fetch events:', error);
                setEvents([]);
            } finally {
                setLoadingEvents(false);
            }
        };

        fetchEvents();
    }, [user, engine]);

    const contextValue = {
        events,
        loadingEvents,
        onEdit: () => {}, // No-op
        onDelete: () => {}, // No-op
        setLoading: () => {}, // No-op
        setData: () => {}, // No-op
        editingLevelId: null
    };

    return (
        <MyObjectivesContext.Provider value={contextValue}>
            {children}
        </MyObjectivesContext.Provider>
    );
};

export const useMyObjectivesContext = () => {
    const context = React.useContext(MyObjectivesContext);
    if (!context) {
        throw new Error('useMyObjectivesContext must be used within a MyObjectivesWrapper');
    }
    return context;
};

const MyObjectivesPage = () => {
    return (
        <MyObjectivesWrapper>
            <MyObjectivesList />
        </MyObjectivesWrapper>
    )
}

export default MyObjectivesPage
